import { callZpayFunction } from '../../callZpayFunction';

// '바로 결제' 메뉴를 통한 주문서 생성 : `zpay.createOrderSheet(url, title, type)`
// 옵션창이 닫히면서 전달 받은(주문서) 화면으로 이동합니다
export const createOrderSheet = (url: string, title: string, type: string) => {
  callZpayFunction('createOrderSheet')({ url, title, type });
};
